var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',{attrs:{"bodyWrapper":""}},[_c('p',{staticClass:"h4 m-0"},[_vm._v(_vm._s(_vm.greeting)+" "+_vm._s(_vm.role)+", "+_vm._s(_vm.name)+"!")])])}
var staticRenderFns = []

export { render, staticRenderFns }